import { Insurance, Consumer } from 'store/profile/types';
import Config from 'react-native-config';
import { oc } from 'ts-optchain';
import dayjs from 'dayjs';

import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export interface InsuranceVerificationRequestDto {
  subscriberId: string; // '304447957A';
  sequence: string; // '1';
  planName: string; // 'MEDICARE';
  planCode: string; // '010';
  groupId: string; // '';
  member: {
    firstName: string; // 'SANDRA';
    middleName: string; // 'K';
    lastName: string; // 'DICKINSON';
    ssn: string; // '304447957';
    dateOfBirth: string; // '2016-05-02T23:48:14.2231015-04:00';
  };
  subscriber: {
    firstName: string; // 'SANDRA';
    middleName: string; // 'K';
    lastName: string; // 'DICKINSON';
    ssn: string; // '123456789';
    dateOfBirth: string; // '2016-05-02T23:48:14.2231015-04:00';
  };
  facilityCode: string;
}

export const createInsuranceVerificationRequestBody = (
  insurance: Insurance,
  consumer: Consumer
): InsuranceVerificationRequestDto => {
  const member = insurance.members
    ? insurance.members.find(m => m.consumerId === consumer.consumerId)
    : null;

  return {
    subscriberId: insurance.subscriberId,
    sequence: oc(member).suffix('0'),
    planName: insurance.planName,
    planCode: insurance.planCode,
    groupId: oc(insurance).groupId(''),
    member: {
      firstName: oc(member).firstName(''),
      middleName: oc(member).middleName(''),
      lastName: oc(member).lastName(''),
      dateOfBirth: dayjs(consumer.dateOfBirth, 'MM/DD/YYYY').toISOString(),
      ssn: ''
    },
    subscriber: {
      firstName: oc(insurance).subscriber.firstName(''),
      middleName: oc(insurance).subscriber.middleName(''),
      lastName: oc(insurance).subscriber.lastName(''),
      dateOfBirth: dayjs(oc(insurance).subscriber.dateOfBirth(''), 'MM/DD/YYYY').toISOString(),
      ssn: ''
    },
    facilityCode: Config.INSURANCE_VERIFICATION_FACILITY_CODE
  };
};
